/**
 * Una pregunta que llega al chat del asistente desde FUERA de él (DV3): un dictado
 * de tarea por voz que en realidad era una pregunta («¿cuánto Oroquin me queda?»)
 * no crea una tarjeta: abre el asistente con esa pregunta ya escrita, para que la
 * persona la mande (o la corrija) con un toque.
 *
 * Un almacén de un solo hueco + un evento, en vez de ampliar AssistantContext: el
 * chat puede no estar montado aún (en escritorio vive en /advanced) y lo recoge al
 * montarse; si ya lo está, le llega por el evento.
 */
const EVENT = "ulture:assistant-question";
let pending: string | null = null;

export function askAssistantLater(question: string): void {
  const q = question.trim();
  if (!q) return;
  pending = q;
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(EVENT, { detail: q }));
}

/** La pregunta pendiente, UNA vez (quien la recoge la vacía). */
export function takePendingQuestion(): string | null {
  const q = pending;
  pending = null;
  return q;
}

/** Suscribirse a preguntas que llegan con el chat ya montado. Devuelve la baja. */
export function onAssistantQuestion(cb: (q: string) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const h = (e: Event) => {
    const q = (e as CustomEvent<string>).detail;
    if (typeof q === "string" && q.trim()) {
      pending = null;
      cb(q);
    }
  };
  window.addEventListener(EVENT, h);
  return () => window.removeEventListener(EVENT, h);
}

/* ── Y al revés: una TAREA preparada en el chat que abre el panel de voz ──────
   draft_task (asistente) pinta un botón con el texto de la tarea; al pulsarlo se
   deja aquí y el panel de tarea por voz lo interpreta como si se hubiera dictado. */
const DRAFT_EVENT = "ulture:assistant-task-draft";
let pendingDraft: string | null = null;

export function setPendingTaskDraft(text: string): void {
  const t = text.trim();
  if (!t) return;
  pendingDraft = t;
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(DRAFT_EVENT, { detail: t }));
}

export function takePendingTaskDraft(): string | null {
  const t = pendingDraft;
  pendingDraft = null;
  return t;
}

/** El panel ya abierto recibe el borrador por aquí (y lo vacía del hueco). */
export function onTaskDraft(cb: (text: string) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const h = (e: Event) => {
    const t = (e as CustomEvent<string>).detail;
    if (typeof t === "string" && t.trim()) cb(t);
  };
  window.addEventListener(DRAFT_EVENT, h);
  return () => window.removeEventListener(DRAFT_EVENT, h);
}
